<template>
	<div class="container">
		<div class="breadcrumb">
			<el-breadcrumb separator=">" style="">
				<el-breadcrumb-item :to="{ path: '/home' }">
					<div style="display: flex; align-items: center; margin-left: 15px">
						<el-icon>
							<Location />
						</el-icon>
						<span style="margin-left: 5px">首页</span>
					</div>
				</el-breadcrumb-item>
				<el-breadcrumb-item @click="$router.go(-1)" style="cursor: pointer">{{
          $route.query.name
          }}</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<template v-if="article">
			<div class="article" id="article">
				<h2 class="article-title">{{ article.title }}</h2>
				<div class="article-desc">
					<span>发布日期：{{ article.publish_time }}</span>
					<span style="margin: 0 15px">作者：{{ article.author }}</span>
					<span>阅读量：{{ article.views }}</span>
				</div>
				<renderHTML class="article-content" :HTML="article.content"></renderHTML>
				<div class="article-link" v-if="article.attachments.length">
					<div style="font-size: 20px; font-weight: 500; margin-bottom: 15px; color: #015293">
						相关附件
					</div>
					<div class="article-link-item" v-for="(item,index) in article.attachments">
						<span class="dot"></span>
						<div style="display: flex; justify-content: space-between; flex: 1">
							<a :href="'http://' + mediaUrl + '/media' + item" download>附件-{{index+1}}</a>
						</div>
					</div>
				</div>
				<div class="article-message" id="message" v-if="article.comments_open">
					<div class="article-message-title">留言</div>
					<div style="margin-bottom: 20px; display: flex">
						<el-input placeholder="请输入您的留言~" v-model="message" type="textarea" :rows="3" :maxlength="2000"
							:minlength="15" resize="none" :autosize="{ minRows: 3, maxRows: 10 }" show-word-limit>
						</el-input>
						<el-button @click="sendHandler" :icon="Position" type="primary" style="
              background-color: #1764a2;
              border-color: #1764a2;
              height: 75px;
              margin-left: 15px;
            ">留言</el-button>
					</div>
					<div class="article-message-list" v-if="messageList.length">
						<div class="article-message-item" v-for="item in messageList">
							<img src="@/assets/logo.png" style="width: 60px; height: 60px; border-radius: 50%; margin-right: 15px"
								alt="" />
							<div style="flex: 1">
								<div style="display: flex; justify-content: space-between">
									<div style="color: #015293; margin-bottom: 15px">
										{{ item.creator.name }}
										<span v-if="Object.keys(item.parent) != 0">回复 {{ item.parent.creator }}</span>
									</div>
									<div style="color: #8f8f8f">{{ item.create_time }}</div>
								</div>
								<div style="margin-bottom: 15px">{{ item.content }}</div>
								<div style="margin-bottom: 15px">
									<el-input v-if="item.flag" placeholder="请输入你的回复" type="textarea" v-model="item.message" :rows="3"
										:maxlength="2000" :minlength="15" resize="none" :autosize="{ minRows: 3, maxRows: 10 }"
										show-word-limit></el-input>
								</div>
								<div style="display: flex; justify-content: space-between; margin-bottom: 15px">
									<div class="hover-text" @click="messageHandler(item)">
										{{ item.flag ? "确认回复" : "回复" }}
									</div>
									<el-button v-show="hasPermission('article-list','comment')" type="danger" icon="Delete" size="small"
										@click="delHandler(item)">删除</el-button>
								</div>
							</div>
						</div>

						<div style="display: flex; justify-content: flex-end">
							<el-pagination background layout="prev, pager, next" :total="10" />
						</div>
					</div>
					<el-empty v-else description="当前暂无留言"></el-empty>
				</div>
			</div>
		</template>
		<el-skeleton v-else class="article" :rows="18" animated />
	</div>
</template>

<script setup>
	import {
		ref,
		reactive,
		watch
	} from "vue";
	import {
		mediaUrl
	} from "@/api/url";
	import {
		articleGetDetail,
		commentGet,
		commentPost,
		commentDelete
	} from "@/api/court";
	import renderHTML from "@/components/renderHTML/index"
	import {
		downloadFileURLByA
	} from "@/utils/util";
	import {
		useRoute
	} from "vue-router";
	import {
		useMutitabsStore
	} from "@/store/mutitabs";
	import {
		ElMessage,
		ElMessageBox
	} from "element-plus";
	import {
		Position
	} from "@element-plus/icons-vue";

	const mutitabsstore = useMutitabsStore();
	const route = useRoute();

	const delFlag = ref(false);
	const article = ref(null);
	const message = ref("");
	const messageInfo = reactive({
		content: "",
		article: route.query.id,
		user: mutitabsstore.userId,
		parent: "",
	});
	const messageParam = reactive({
		page: 1,
		limit: 10,
		article: route.query.id,
		total: 0,
	});

	const messageList = ref([]);

	function messageInit() {
		commentGet(messageParam).then((res) => {
			if (res.data.code == 2000) {
				messageParam.total = res.data.data.total;
				res.data.data.data.map((item) => {
					item.flag = false;
					item.message = "";
				});

				messageList.value = res.data.data.data;
			}
		});
	}

	function sendHandler() {
		if (message.value.trim() == "") return ElMessage.warning("请输入内容后留言");
		messageInfo.parent = "";
		messageInfo.content = message.value;
		commentPost(messageInfo).then((res) => {
			if (res.code == 2000) {
				ElMessage.success("留言成功~");
				message.value = "";
				messageInit();
			}
		});
	}

	function messageHandler(param) {
		param.flag = !param.flag;

		if (!param.flag && param.message.trim()) {
			messageInfo.parent = param.id;
			messageInfo.content = param.message;
			commentPost(messageInfo).then((res) => {
				if (res.code == 2000) {
					ElMessage.success("回复成功~");
					param.message = "";
					messageInit();
				}
			});
		}
	}

	function delHandler(param) {
		ElMessageBox.confirm("是否确认删除当前留言", "提示", {
			confirmButtonText: "确定",
			cancelButtonText: "取消",
			type: "warning",
		}).then((f) => {
			commentDelete(param).then((res) => {
				if (res.code == 2000) {
					ElMessage.success("删除成功~");
					messageInit();
				}
			});
		});
	}

	function initPage() {
		delFlag.value = mutitabsstore.roleNames.split(",").indexOf("管理员") != -1; //等于-1为没有权限
		articleGetDetail(route.query.id).then((res) => {
			if (res.data.code == 2000) {
				res.data.data.data.attachments = res.data.data.data.attachments.split(",").filter(node => node != "")
				
				article.value = res.data.data.data;

				if (article.value.content) {
					// 使用正则表达式匹配所有的 img 标签的 src 属性
					const imgRegex = /<img[^>]*src="([^">]+)"/gi;
					const videoRegex = /<source[^>]*src="([^">]+)"/gi;

					// 正则表达式，用于匹配 a 标签的 href 属性
					const aRegex = /<a[^>]*href="([^">]+)"/gi;

					article.value.content = article.value.content
						.replace(imgRegex, (match, src) => {
							const newSrc = `http://${mediaUrl}/media/${src}`;
							return match.replace(src, newSrc);

						})
						.replace(aRegex, (match, href) => {
							// 这里可以根据需要处理 href，比如添加前缀或进行其他转换
							// 返回替换后的 a 标签

							const newHref = `http://${mediaUrl}/media/${href}`;
							return match.replace(href, newHref);

						})	
						.replace(videoRegex, (match, href) => {
							// 这里可以根据需要处理 href，比如添加前缀或进行其他转换
							// 返回替换后的 a 标签

							const newVideo= `http://${mediaUrl}/media/${href}`;
							return match.replace(href, newVideo);

						});
				}

				messageParam.article = article.value.id;
				if (article.value.comments_open) messageInit();
			}
		});
	}

	watch(_ => route.query.id, _ => {
		initPage()
	}, {
		deep: true,
		immediate: true
	})
</script>

<style lang="scss" scoped>
	.container {
		width: 1200px;
		margin: 0 auto;
		padding-top: 20px;

		.breadcrumb {
			margin-bottom: 15px;
			border-bottom: 5px solid #ddd;
			padding-bottom: 8px;
		}

		.article {
			.article-title {
				text-align: center;
				color: #355e92;
				font-size: 22px;
				margin-bottom: 35px;
			}

			.article-desc {
				text-align: center;
				color: #777;
				margin-bottom: 55px;
			}

			.article-content {
				margin-bottom: 50px;
				padding-bottom: 30px;
				border-bottom: 3px solid #ddd;
			}

			.article-link {
				margin-bottom: 30px;

				.article-link-item {
					display: flex;
					align-items: center;
					margin-bottom: 15px;
					cursor: pointer;

					.dot {
						content: "";
						display: table;
						width: 5px;
						height: 5px;
						background-color: #e1dfdf;
						margin-right: 5px;
					}

					&:hover .dot {
						background-color: #015293 !important;
					}

					&:hover {
						color: #015293;
					}
				}
			}

			.article-message {
				.article-message-title {
					font-size: 20px;
					font-weight: 500;
					margin-bottom: 25px;
					color: #015293;
					padding-bottom: 15px;
					border-bottom: 2px solid #ddd;
				}

				.article-message-list {
					margin-bottom: 100px;

					.article-message-item {
						box-sizing: border-box;
						padding: 0.5em 0.8em;
						border: 1px solid #ddd;
						margin-bottom: 15px;
						display: flex;
						border-radius: 6px;

						.hover-text {
							color: #015293;
							cursor: pointer;
						}
					}
				}
			}
		}
	}
</style>